// extracted by mini-css-extract-plugin
export var gif = "_dm-0";